let arr =  [
    {
        title: "Mount Fuji",
        location: "Japan",
        googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
        startDate: "12 Jan, 2021",
        endDate: "24 Jan, 2021",
        description: "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
        imageUrl: "https://source.unsplash.com/WLxQvbMyfas",
        more: "https://www.britannica.com/place/Mount-Fuji"
    },
    {
        title: "Sydney Opera House",
        location: "Australia",
        googleMapsUrl: "https://www.google.com/maps/place/Sydney+Opera+House/@-33.8567844,151.213108,17z/data=!3m2!4b1!5s0x6b12ae67d234a27f:0xd6d4e9380ca1e32f!4m5!3m4!1s0x6b12ae665e892fdd:0x3133f8d75a1ac251!8m2!3d-33.8567844!4d151.2152967",
        startDate: "27 May, 2021",
        endDate: "8 June, 2021",
        description: "The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings",
        imageUrl: "https://source.unsplash.com/JmuyB_LibRo",
        more:"https://www.britannica.com/topic/Sydney-Opera-House"
    },
    {
        title: "Geirangerfjord",
        location: "norway",
        googleMapsUrl: "https://www.google.com/maps/search/Geirangerfjord/@62.104831,7.0120268,12z/data=!3m1!4b1",
        startDate: "01 Oct, 2021",
        endDate: "18 Nov, 2021",
        description: "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality.",
        imageUrl: "https://source.unsplash.com/3PeSjpLVtLg",
        more: "https://www.fjordtours.com/things-to-do-in-norway/the-norwegian-fjords/the-geirangerfjord/"
    }
]

export default arr